<div class="text-center">
    <div class="pt-80">
        <h1 class="text-9xl font-bold text-slate-900">Coming Soon!!</h1>
    </div>
</div>
